import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    mainContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    timelineContainer: {
      width: "100%",
    },
  };
});
